import { Component, Input, Inject, EventEmitter, ElementRef, ViewChild, HostListener, Output, SimpleChanges } from "@angular/core";
import { BaseComponent } from "../..";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../../../../shared/providers";
import { ConfPageSessionService, ConfiguratorStore } from "../../../configurator/providers";
import { PageStore } from "../../providers/page";
import { RequestViews } from "../../models/requests/requestViews";

@Component({
  selector: 'track-systems-controls',
  templateUrl: './trackSystemsControlsComponent.html',
})
export class TrackSystemsControlsComponent extends BaseComponent {
  snapToAngleAPIUrl = "fagerhult/tracksystems/snaptoangle";
  uploadDrawingAPIUrl = "fagerhult/tracksystems/uploaddrawing";
  scaleDrawingAPIUrl = "fagerhult/tracksystems/scaledrawing";
  drawTrackAPIUrl = "fagerhult/tracksystems/drawtrack";
  addLuminaireAPIUrl = "fagerhult/tracksystems/addluminaire";

  @Input()
  public showSnapToAngleOnButton;

  @Input()
  public showUploadDrawingButton;

  @Input()
  public showScaleDrawingButton;

  @Input()
  public showDrawTrackButton;

  @Input()
  public showAddLuminaireButton;

  @Input()
  public showCancelAddLuminaireButton;

  @Input()
  public container: ElementRef;

  @Input()
  public confId: number;

  constructor(
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(PageStore) public pageStore: PageStore,
    protected httpClient: HttpClient,
    protected httpService: HttpService
  ) {
    super();
  }

  public async snapToAngleClick() {
    await this.httpClient.request("get", `${this.getUrl(this.snapToAngleAPIUrl)}`).toPromise();
  }

  public async uploadDrawingClick() {
    await this.httpClient.request("get", `${this.getUrl(this.uploadDrawingAPIUrl)}`).toPromise();
  }

  public async scaleDrawingClick() {
    let scale = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.a;
    let panX = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.e;
    let panY = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.f;

    panX = -panX / scale + window.innerWidth / scale / 3;
    panY = -panY / scale + window.innerHeight / scale / 3;

    await this.httpClient.request("get", `${this.getUrl(this.scaleDrawingAPIUrl)}&panX=${panX}&panY=${panY}`).toPromise();
  }

  public async drawTrackClick() {
    let scale = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.a;
    let panX = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.e;
    let panY = (this.container as any).firstElementChild.lastElementChild.transform.baseVal[0].matrix.f;

    panX = -panX / scale + window.innerWidth / scale / 3;
    panY = -panY / scale + window.innerHeight / scale / 3;

    await this.httpClient.request("get", `${this.getUrl(this.drawTrackAPIUrl)}&panX=${panX}&panY=${panY}`).toPromise();
  }

  public async addLuminaireClick() {
    await this.httpClient.request("get", `${this.getUrl(this.addLuminaireAPIUrl)}`).toPromise();
  }

  getUrl(url: string) {
    return `${this.httpService.createUrl(url)}&confSessionId=${this.confPageSessionService.confSessionId}&confId=${this.confPageSessionService.activeConfigurationId}`;
  }
}